// Fatia S3a: relatório público somente leitura (/r/:token), com o nome da empresa e da agência.
import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Download, Sparkles } from 'lucide-react'
import { ApiError, errorMessage } from '../../lib/api'
import { isDeadLink, isTransient } from '../../features/auth/link-errors'
import { Loading } from '../../ui'
import { ReportView } from '../../features/reports/ReportView'
import { downloadPdf, useSharedReport } from '../../features/reports/api'

const periodLabel = (d: number) => (d === 90 ? 'últimos 3 meses' : `últimos ${d} dias`)
const dateBr = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`

export default function SharedReport() {
  const { token = '' } = useParams()
  const q = useSharedReport(token)
  const [downloading, setDownloading] = useState(false)
  const [pdfError, setPdfError] = useState<string | null>(null)
  const brand = q.data?.agency
  const color = brand?.primaryColor ?? 'var(--primary)'

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <header style={{ background: 'white', borderBottom: '1px solid var(--border)' }}>
        <div className="row" style={{ maxWidth: 1100, margin: '0 auto', padding: '14px 16px', gap: 10 }}>
          {brand ? <span className="logo-mark" style={{ background: color }}><Sparkles size={17} /></span> : <img src="/logo.png" alt="" className="logo-img" />}
          <span className="strong">{brand?.name ?? 'Seu Impulso'}</span>
        </div>
      </header>
      <main style={{ maxWidth: 1100, margin: '0 auto', padding: '24px 16px 48px' }}>
        {q.isLoading && <div className="card"><Loading lines={6} /></div>}
        {q.isError && (
          <div className="card empty" role="alert">
            <h3 style={{ color: 'var(--text)' }}>{q.error instanceof ApiError && q.error.status === 410 ? 'Este link expirou' : isDeadLink(q.error) ? 'Este link não vale mais' : 'Relatório indisponível'}</h3>
            <p className="mt-8">{isDeadLink(q.error) ? 'Peça um novo link a quem enviou este relatório.' : errorMessage(q.error)}</p>
            <div className="row mt-16" style={{ justifyContent: 'center', gap: 8 }}>
              {isTransient(q.error) && <button type="button" className="btn primary" onClick={() => void q.refetch()}>Tentar de novo</button>}
              <Link className="btn" to="/">Conhecer o Seu Impulso</Link>
            </div>
          </div>
        )}
        {q.data && (
          <div className="stack" style={{ gap: 20 }}>
            <div className="page-head" style={{ marginBottom: 0 }}>
              <div>
                <h1>Resultados de {q.data.companyName}</h1>
                <p className="sub">
                  Anúncios nos {periodLabel(q.data.report.period.days)} ({dateBr(q.data.report.period.from)} a {dateBr(q.data.report.period.to)}).
                  {brand ? ` Relatório preparado por ${brand.name}.` : ''}
                </p>
              </div>
              <div className="actions">
                <button
                  className="btn"
                  disabled={downloading}
                  onClick={async () => {
                    setDownloading(true)
                    setPdfError(null)
                    try { await downloadPdf(`/shared-reports/${encodeURIComponent(token)}/pdf`, 'relatorio.pdf') } catch (err) { setPdfError(errorMessage(err)) } finally { setDownloading(false) }
                  }}
                >
                  <Download size={16} /> {downloading ? 'Gerando…' : 'Baixar PDF'}
                </button>
              </div>
            </div>
            {pdfError && <p className="small" style={{ color: 'var(--red)' }}>{pdfError}</p>}
            {q.data.report.hasData
              ? <ReportView report={q.data.report} />
              : <div className="card empty">Ainda não há resultados neste período.</div>}
            <p className="small muted" style={{ textAlign: 'center' }}>
              Somente leitura · link válido até {new Date(q.data.expiresAt).toLocaleDateString('pt-BR')}. Vendas e retorno são estimativas.
            </p>
          </div>
        )}
      </main>
    </div>
  )
}
